export default __webpack_public_path__ + "static/seedlefinance-738d8c8243c2f95b4c9347c5db94e6f9.jpg";